var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2702_3469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5745 14.8408C11.5251 14.8408 14.4944 14.8408 14.4944 14.8408C15.2817 14.8408 15.9197 14.2029 15.9197 13.4155C15.9197 12.6282 15.2817 11.9902 14.4944 11.9902C13.7817 11.9902 12.3565 11.9902 8.79322 11.9902C5.22927 11.9902 4.10131 13.4749 2.85402 14.7222L0.590844 16.699C0.444359 16.8264 0.359375 17.0117 0.359375 17.2058V23.7757C0.359375 23.8636 0.410656 23.9434 0.490484 23.98C0.570312 24.0159 0.664062 24.0035 0.730719 23.9463L5.10477 20.1963C5.25931 20.0652 5.46439 20.0096 5.66361 20.0454L12.4795 21.2847C12.9549 21.3711 13.4449 21.262 13.8396 20.9829C13.8396 20.9829 22.5401 14.9338 23.1817 14.3991C23.794 13.8374 23.7867 13.0222 23.2249 12.4099C22.6624 11.7961 21.6136 11.9264 20.9141 12.4443C20.2732 12.9789 15.8948 15.8566 15.8948 15.8566H10.5745L10.5577 15.8639C10.2772 15.8551 10.0582 15.62 10.067 15.3403C10.0772 15.0598 10.3116 14.84 10.5914 14.8495L10.5745 14.8408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 0C15.7039 0 14.5715 0.692859 13.9453 1.72706C15.9478 2.46169 17.3833 4.38211 17.3833 6.63577C17.3833 6.80203 17.3738 6.96609 17.3584 7.1287C19.1639 6.94852 20.5738 5.42583 20.5738 3.57281C20.5738 1.59961 18.9742 0 17.0002 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.282 5.68262H11.7188V6.81713H12.282C12.6387 6.81713 12.9287 6.56223 12.9287 6.24952C12.9287 5.93752 12.6387 5.68262 12.282 5.68262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1543 2.55176C9.89919 2.55176 8.07031 4.38063 8.07031 6.63574C8.07031 8.8916 9.89919 10.7197 12.1543 10.7197C14.4094 10.7197 16.2383 8.8916 16.2383 6.63574C16.2383 4.38063 14.4095 2.55176 12.1543 2.55176ZM12.2825 7.44654H11.7192V8.27196C11.7192 8.43091 11.5903 8.55907 11.4321 8.55907H11.2879C11.1289 8.55907 11.0007 8.43091 11.0007 8.27196V5.33937C11.0007 5.18116 11.1289 5.05226 11.2879 5.05226H12.2825C13.0362 5.05226 13.6485 5.58912 13.6485 6.24902C13.6484 6.90968 13.0362 7.44654 12.2825 7.44654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2702_3469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyPoints);
export default __webpack_public_path__ + "static/media/ic-my-points.5d821623a4fcaf90d5022920b6554469.svg";
export { ForwardRef as ReactComponent };